import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d564339"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-background" }
const _hoisted_2 = {
  key: 0,
  class: "shemi"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "hint" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_carousel = _resolveComponent("a-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showShemi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.jinzhishangchuan')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_carousel, {
      dots: false,
      speed: 1200,
      fade: true,
      ref: "varousel"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["login-background-sky", item]),
            key: item
          }, null, 2))
        }), 128))
      ]),
      _: 1
    }, 512),
    (_ctx.showIcp)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "copy-right",
          target: "_blank",
          href: "https://beian.miit.gov.cn/",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goto && _ctx.goto(...args)))
        }, "鄂ICP备18027246号-6"))
      : _createCommentVNode("", true)
  ]))
}